import { get, Post } from "../request/axios";
export default {
  name: "home",
  data() {
    return {
      imgurl: "",
      player: null,
      type: false,
      cover: "",
      // 封面
      playStatus: false,
      //是否自动播放
      muteStatus: false,
      // 是否静音自动播放
      mp4Url: "",
      options: {
        type: Object,
        default() {
          return {};
        }
      },
      title: "",
      sub: "",
      bgurl: "",
      textTitle: "黎里探究"
    };
  },
  created() {
    document.title = "柳亚子纪念馆";
  },
  mounted() {
    this.show(this.$route.params.type, this.$route.params.id);
    this.getJsonData(this.$route.params.type, this.$route.params.id);
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    show(t, u) {
      switch (t) {
        case "img":
          this.type = true;
          this.imgurl = "/img/" + u + ".png";
          break;
        case "video":
          this.type = false;
          this.mp4Url = "/mp4/" + u + ".mp4";
          break;
      }
    },
    getJsonData(t, i) {
      var that = this;
      if (t == "video") {
        that.bgurl = "/bg/bg3.png";
        //console.log(str)
        var url = "/json/" + t + i + ".json";
        get(url).then(res => {
          that.title = res.title;
          that.sub = res.sub;
          console.log(res);
        });
      }
    }
  }
};